module.exports = __webpack_public_path__ + "img/solution-market3.8a86ce80.png";